/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdAgentsResearch200Ok
 */
export interface GetCharactersCharacterIdAgentsResearch200Ok {
    /**
     * agent_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdAgentsResearch200Ok
     */
    agentId: number;
    /**
     * points_per_day number
     * @type {number}
     * @memberof GetCharactersCharacterIdAgentsResearch200Ok
     */
    pointsPerDay: number;
    /**
     * remainder_points number
     * @type {number}
     * @memberof GetCharactersCharacterIdAgentsResearch200Ok
     */
    remainderPoints: number;
    /**
     * skill_type_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdAgentsResearch200Ok
     */
    skillTypeId: number;
    /**
     * started_at string
     * @type {Date}
     * @memberof GetCharactersCharacterIdAgentsResearch200Ok
     */
    startedAt: Date;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdAgentsResearch200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdAgentsResearch200Ok(value: object): value is GetCharactersCharacterIdAgentsResearch200Ok {
    if (!('agentId' in value) || value['agentId'] === undefined) return false;
    if (!('pointsPerDay' in value) || value['pointsPerDay'] === undefined) return false;
    if (!('remainderPoints' in value) || value['remainderPoints'] === undefined) return false;
    if (!('skillTypeId' in value) || value['skillTypeId'] === undefined) return false;
    if (!('startedAt' in value) || value['startedAt'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdAgentsResearch200OkFromJSON(json: any): GetCharactersCharacterIdAgentsResearch200Ok {
    return GetCharactersCharacterIdAgentsResearch200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdAgentsResearch200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdAgentsResearch200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'agentId': json['agent_id'],
        'pointsPerDay': json['points_per_day'],
        'remainderPoints': json['remainder_points'],
        'skillTypeId': json['skill_type_id'],
        'startedAt': (new Date(json['started_at'])),
    };
}

export function GetCharactersCharacterIdAgentsResearch200OkToJSON(json: any): GetCharactersCharacterIdAgentsResearch200Ok {
    return GetCharactersCharacterIdAgentsResearch200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdAgentsResearch200OkToJSONTyped(value?: GetCharactersCharacterIdAgentsResearch200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'agent_id': value['agentId'],
        'points_per_day': value['pointsPerDay'],
        'remainder_points': value['remainderPoints'],
        'skill_type_id': value['skillTypeId'],
        'started_at': ((value['startedAt']).toISOString()),
    };
}

